/**
 * Универсальный Popover-компонент для UI-библиотеки.
 * Обёртка над MUI Popover, принимает все стандартные пропсы Popover и children для отображения содержимого.
 *
 * @example
 * <Popover open={open} anchorEl={anchorEl} onClose={handleClose}>
 *   <div>Контент поповера</div>
 * </Popover>
 */
import React from 'react';

import {
  Popover as MuiPopover,
  PopoverProps as MuiPopoverProps,
} from '@mui/material';

/**
 * Пропсы универсального Popover-компонента.
 * Наследует все стандартные пропсы MUI Popover и требует children.
 */
export interface PopoverProps extends MuiPopoverProps {
  /** Содержимое, которое будет отображено внутри поповера */
  children: React.ReactNode;
}

export const Popover: React.FC<PopoverProps> = ({ children, ...props }) => (
  <MuiPopover {...props}>{children}</MuiPopover>
);
